/** Что сервер требует сделать до работы в CRM (CRM-122). Номера — `RequiredAction` сервера. */
export enum RequiredAction {
  ChangePassword = 1
}

/** Состояние пароля сотрудника (`PasswordState` сервера). */
export enum PasswordState {
  Own = 0,
  TemporaryActive = 1,
  TemporaryExpired = 2,
  NotSet = 3
}

/** Вид события журнала безопасности (`SecurityEventKind` сервера, номера сверяет `checks/auth.check.ts`). */
export enum SecurityEventKind {
  LoginSucceeded = 1,
  LoginFailed = 2,
  Logout = 3,
  SessionRevoked = 4,
  UserCreated = 5,
  UserChanged = 6,
  PasswordChanged = 7,
  PasswordReset = 8,
  UserBlocked = 9,
  UserUnblocked = 10,
  LockedOut = 11,
  LockoutCleared = 12,
  LoginRateLimited = 13
}

export interface IChangePasswordRequest {
  currentPassword?: string;
  newPassword: string;
}
